export class MultiRiskAttibuteModelItem {
  public dataRobotAttributeId: number;
  public id: number;
  public modelId: number;
  public operatorId: number;
  public value: string;
  public dataRobotAttributeName: string;
  public operatorDescription: string;

  constructor(data: any, attributes: any, operators: any) {
    this.dataRobotAttributeId = data.dataRobotAttributeId;
    this.id = data.id;
    this.modelId = data.modelId;
    this.operatorId = data.operatorId;
    this.value = data.value;
    attributes.forEach((element: any) => {
      if (element.id === this.dataRobotAttributeId) {
        this.dataRobotAttributeName = element.description;
      }
    });
    operators.forEach((element: any) => {
      if (element.id === this.operatorId) {
        this.operatorDescription = element.operator;
      }
    });
  }
}
